export type RandomSnapshot = Readonly<{ state: number }>;

export class SeededRandom {
  private state: number;

  public constructor(seed: number) {
    const normalized = seed >>> 0;
    this.state = normalized === 0 ? 0x6d2b79f5 : normalized;
  }

  public nextUint32(): number {
    let value = this.state;
    value ^= value << 13;
    value ^= value >>> 17;
    value ^= value << 5;
    this.state = value >>> 0;
    return this.state;
  }

  public nextFloat(): number {
    return this.nextUint32() / 0x1_0000_0000;
  }

  public nextInt(exclusiveMaximum: number): number {
    if (!Number.isInteger(exclusiveMaximum) || exclusiveMaximum <= 0) {
      throw new RangeError('exclusiveMaximum must be a positive integer');
    }
    return Math.floor(this.nextFloat() * exclusiveMaximum);
  }

  public snapshot(): RandomSnapshot {
    return { state: this.state };
  }

  public restore(snapshot: RandomSnapshot): void {
    this.state = snapshot.state >>> 0;
  }
}
